import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface offerState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: offerState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const offerSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setOffer: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewOffer: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setOffer, addNewOffer, reset } = offerSlice.actions;
export const getOffer = (state: RootState) => state.offer.data;
export const getOfferTotalRecord = (state: RootState) => state.offer.totalRecords;

export default offerSlice.reducer;
